import BreadCrumb from '@/components/breadcrumb/breadcrumb-component';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Col } from '../grid/grid-component';

const Wrapper = styled.div`
  padding: 32px;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  justify-content: center;
  width: 100%;
`;

/**
 *
 * Renders a page layout with optional elements like breadcrumb and Outlet.
 * @param {boolean} fullWidth  Whether to display full width or not
 * @returns {JSX.Element} The rendered User Management page component.
 */
const CRUDPageWrapper = ({ fullWidth }) => {
  const location = useLocation();

  return (
    <Wrapper>
      <BreadCrumb />
      <Col xs={fullWidth ? 12 : 9}>
        <Outlet key={location.key} />
      </Col>
    </Wrapper>
  );
};

CRUDPageWrapper.defaultProps = {
  fullWidth: false,
};

CRUDPageWrapper.propTypes = {
  fullWidth: PropTypes.bool,
};

export default CRUDPageWrapper;
